import TwitterStream from '../parts/TwitterStream.js';
import Dashboard from '../parts/Dashboard.js';

var React = require('react');


//Results Holds the Dashboard and TwitterStream Components
//Uses Dashboard.js and TwitterStream.js

/*
function index(props) {
    return (
        <div className="results container-fluid">
            <div className="row">
                <Dashboard
                    binnedTweets={props.binnedTweets}
                    totalTweets={props.totalTweets}
                    sentiment={props.sentiment}
                />
                <TwitterStream collectedTweets={props.collectedTweets}/>
            </div>
        </div>
    );
}
*/

function index(props) {
    return (
        <div className="results container-fluid">
            <div className="row">
                <Dashboard
                    binnedTweets={props.binnedTweets}
                    totalTweets={props.totalTweets}
                    sentiment={props.sentiment}
                />
                <TwitterStream collectedTweets={props.collectedTweets}/>
            </div>
        </div>
    );
}

export default index;